const { createSlice } = require('@reduxjs/toolkit');

const lineItemSlice = createSlice({
    name: "lineItem",
    initialState: {
        status: false,
    },
    reducers: {
        setlineItem(state) {
            // Toggle the status each time this reducer is called
            state.status = !state.status;
        }
    },
});

export const { setlineItem } = lineItemSlice.actions;
export default lineItemSlice.reducer;
